<template>
  <div class="ganttv2 mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/TS001_V2"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" id="rightWrap" style="height:100%;width:100%;">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('pageTitle.TireStep2')}}</h1>
                <!-- 查询条件 -->
                <div class="condition">
                  <!-- 时间筛选条件 -->
                  <div class="selectTime">
                    <p>{{$t('MachineDashBoard.class6')}}：</p>
                    <el-date-picker
                      v-model="dataTime"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      @change="changeTime"
                      type="datetimerange"
                      :picker-options="pickerOptions"
                      :editable="false"
                      range-separator="——"
                      :start-placeholder="$t('gantt.StartTime')"
                      :end-placeholder="$t('gantt.EndTime')"
                      popper-class="timePickerGanttV2">
                    </el-date-picker>
                  </div>
                  <!-- 机器id -->
                  <equipment @change="getchange" class="machinevue" :machine="machineId" ></equipment>
                </div>
              </div>
              <!-- 查询按钮 -->
              <div class="seachPart">
                <el-button type="primary" icon="el-icon-view" @click="seachBtn()">{{$t('gantt.showBtn')}}</el-button>
                <div v-if="chartOptions.length !== 0" style="display:inline-block;margin-left:10px;">
                  <el-button plain @click="excelExport">{{$t('gantt.exportBtn')}}</el-button>
                  <!-- <el-select @change="autoRefreshType()" v-model="autoType" class="autoType">
                    <el-option label="停止刷新" value="1"></el-option>
                    <el-option label="5秒" value="2"></el-option>
                    <el-option label="10秒" value="3"></el-option>
                    <el-option label="1分钟" value="4"></el-option>
                  </el-select> -->
                </div>
              </div>
              <div class="content">
                <!-- 单胎id列表 -->
                <el-scrollbar class="machineWrap" style="height:675px;width:178px;">
                  <ul class="tirewrap" >
                    <el-tooltip v-for="item in tireID" :key="item.id" :content="item.tireName" placement="right" effect="light">
                      <li :class="{'mostshort': item.id===leastTire.id,'selected': item.id ===selectTire}" @click="getData(item.id,item.tireName)" > T...{{ item.timeStamp | formatDate}}</li>
                    </el-tooltip>
                  </ul>
                </el-scrollbar>
                <!-- 甘特图 -->
                <div class="ganttPart" v-if="showGantt">
                  <!-- 甘特图标题 -->
                  <div class="ganttTitle" v-show="chartOptions.length !== 0">
                    <div v-show="$store.state.lang===0" class="chartTitle">{{'Step of ' + machineName}}</div>
                    <div v-show="$store.state.lang===1" class="chartTitle">{{machineName + ' 的步序'}}</div>
                    <p>{{ganttStart}} ~ {{ganttEnd}}</p>
                    <div class="toggle">
                      <p v-if="toggleType" @click="toggleType=!toggleType"><i class="el-icon-caret-right"></i>{{$t('ganttv2.expand')}}</p>
                      <p v-else @click="toggleType=!toggleType"><i class="el-icon-caret-bottom"></i>{{$t('ganttv2.collapse')}}</p>
                    </div>
                  </div>
                  <!-- 甘特图 -->
                 <ganttChart class="ganttChart" :options="chartOptions" :type='toggleType'/>
                </div>
              </div>
              
            </div>
            <!-- 底部文字 -->
            <div class="ptbottomfont" v-if="$store.state.newroute ==='zhongce'">
              <span>Power By www.tst-cloud.com</span>
              <a href="http://www.tst-cloud.com/" target="_blank">{{$t('ZcrubberEquiepmentIOT.title')}}</a>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>


import leftNav from "@/components/nav.vue"
import ganttChart from "@/components/ganttComponent.vue"
import equipment from "@/components/Equipment.vue"
import { formatDate } from '../assets/js/date.js'


export default {
  name: 'ganttv2',
  components: {
    leftNav,
    ganttChart,
    equipment
  },
  data () {
    return {
      // 机器 id
      machineId: null,
      machineName:'',
      // loding
      fullscreenLoading: false,
      // 时间
      dataTime:null,
      newTime:null,
      // 自动刷新类型
      autoType: '1',
      // 单胎id
      tireID:[],
      leastTire:'',
      selectTire:'',
      // 甘特图数据
      chartOptions:[],
      visible:false,
      // 查询gantt的开始时间和结束时间
      ganttStart:'',
      ganttEnd: '',
      //日期时间选择快捷选项
      pickerOptions: {
          shortcuts: [{
            text: this.$t('gantt.pickTime1'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('gantt.pickTime2'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 3);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('gantt.pickTime3'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 8);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: this.$t('gantt.pickTime4'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: this.$t('gantt.pickTime5'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit('pick', [start, end]);
            }
          },

          ]
      },
      // 甘特图是否折叠
      toggleType:false,
      showGantt:true,
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyyMMddhhmmss')
    }
  },
  mounted() {
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }
  },
  destroyed() {
    
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineId=value
      // this.changeLine()
    },
    add0(m){return m<10?'0'+m:m },
    format(shijianchuo){
      //shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
    },
    // 切换计算周期的时间
    changeTime(){
      if (this.dataTime === null) {
          this.dataTime=["",""]
      }else{
          let end = new Date();
          let start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 1);
          start = this.format(start)
          end = this.format(end)
          let oneHours = [start,end]

          let endthree = new Date();
          let startthree = new Date();
          startthree.setTime(startthree.getTime() - 3600 * 1000 * 3);
          startthree = this.format(startthree)
          endthree = this.format(endthree)
          let threeHours = [startthree,endthree]

          let endeight = new Date();
          let starteight = new Date();
          starteight.setTime(starteight.getTime() - 3600 * 1000 * 8);
          starteight = this.format(starteight)
          endeight = this.format(endeight)
          let eightHours = [starteight,endeight]

          let endoneday = new Date();
          let startoneday = new Date();
          startoneday.setTime(startoneday.getTime() - 3600 * 1000 * 24 * 1);
          startoneday = this.format(startoneday)
          endoneday = this.format(endoneday)
          let oneday = [startoneday,endoneday]

          let endtwodays = new Date();
          let starttwodays = new Date();
          starttwodays.setTime(starttwodays.getTime() - 3600 * 1000 * 24 * 2);
          starttwodays = this.format(starttwodays)
          endtwodays = this.format(endtwodays)
          let twodays = [starttwodays,endtwodays]

          if(this.dataTime[0]===oneHours[0]&&this.dataTime[1]===oneHours[1] || this.dataTime[0]===threeHours[0]&&this.dataTime[1]===threeHours[1] || this.dataTime[0]===eightHours[0]&&this.dataTime[1]===eightHours[1] || this.dataTime[0]===oneday[0]&&this.dataTime[1]===oneday[1] || this.dataTime[0]===twodays[0]&&this.dataTime[1]===twodays[1]){
              let startTime = this.dataTime[0].split(" ")[1].split(":")
            if(startTime[1] != 0 || startTime[2] != 0){
              startTime[2]="00"
            }
            this.dataTime[0] = this.dataTime[0].split(" ")[0] + ' '+startTime[0]+':'+startTime[1]+':'+startTime[2]
            let endTime = this.dataTime[1].split(" ")[1].split(":")
            if(endTime[1] != 0 || endTime[2] != 0){
              endTime[2]="00"
            }
            this.dataTime[1] = this.dataTime[1].split(" ")[0] + ' '+endTime[0]+':'+endTime[1]+':'+endTime[2]
          }else{
            let startTime = this.dataTime[0].split(" ")[1].split(":")
            if(startTime[1] != 0 || startTime[2] != 0){
              startTime[1]="00"
              startTime[2]="00"
            }
            this.dataTime[0] = this.dataTime[0].split(" ")[0] + ' '+startTime[0]+':'+startTime[1]+':'+startTime[2]
            let endTime = this.dataTime[1].split(" ")[1].split(":")
            if(endTime[1] != 0 || endTime[2] != 0){
              endTime[1]="00"
              endTime[2]="00"
            }
            this.dataTime[1] = this.dataTime[1].split(" ")[0] + ' '+endTime[0]+':'+endTime[1]+':'+endTime[2]
          }

      }
          // this.ganttStart=this.dataTime[0]
          // this.ganttEnd=this.dataTime[1]
    },
    //  获取甘特图参数并传值
    getData(id,name){
      let _this = this
      this.fullscreenLoading = true
      this.axios({
        method: 'get',
        url: '/url/selectMachineStepGanttV2',
        params:{
          tireId: id,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true'){
          _this.chartOptions = res.data.data
          _this.machineName = name
          _this.selectTire = id
          _this.ganttStart = _this.newTime[0]
          _this.ganttEnd = _this.newTime[1]
          _this.toggleType=false
        }else{
          _this.$message.error(res.data.msg);
        }
        _this.fullscreenLoading = false
      })
        
    },

    // 查询按钮
    seachBtn(){
      if(this.machineId === null){
        this.$message({
          message: this.$t('gantt.error1'),
          type: 'warning'
        })
      }else if(this.dataTime === null) {
        this.$message({
          message: this.$t('gantt.error2'),
          type: 'warning'
        })
      }else{
        this.showGantt=false
        this.chartOptions=[]
        this.newTime = this.dataTime
        this.gettireID()
      }
    },
    // 获取轮胎列表
    gettireID(){
      let _this = this
       _this.fullscreenLoading = true
      this.axios({
        method: 'post',
        url:'/url/findTireinfoData',
        params:{
          machineId: _this.machineId,
          startTime: this.newTime[0],
          endTime: this.newTime[1],
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
            _this.showGantt = true
            _this.tireID = res.data.data
            _this.leastTire = res.data.leastTire
        } else {
          _this.tireID=[]
          _this.$message.error(res.data.msg);
        }
        _this.fullscreenLoading = false
      })
    },
    // 导出甘特图数据
    excelExport(){
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      this.urlData = '?tireId='+this.selectTire + '&language=' + this.$store.state.lang+'&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
      window.open('/url/selectMachineStepGanttV2Excel' + this.urlData, '_blank')
    }
  }
}
</script>
<style scoped>
.record{
  height: 100%;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 5px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.idWraps{
  width: 140px;
}
.fixedTime{
  width: 100px;
  display: inline-block;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid #ccc;
}
.fixedTime span{
  display: inline-block;
  width: 50px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;
}
.fixedTime .active{
  color: rgba(103, 114, 229, 1);
}
.condition{
  float: right;
}
.MainidWrap, .fixedTime, .selectTime{
  float: left;
}
.selectTime .el-date-editor--datetimerange.el-input__inner{
  width: 365px;
  padding-right: 0;
}
.MainidWrap{
  padding-right: 10px;
  border-right:1px solid #ccc;
}
.fixedTime{
  margin: 0 10px ;
}
.seachPart{
  padding: 15px 20px;
  text-align: right;
}
.seachPart .autoType{
  width: 120px;
  margin-left: 10px;
}

.ganttTitle{
  text-align: center;
  position: relative;
}
.ganttTitle div{
  color: #505050;
  font-weight: bold;
  font-size: 18px;
}
.ganttTitle p{
  color: rgba(157, 157, 157, 1);
  font-weight: bold;
  font-size: 14px;
  margin: 10px 0 20px;
}
.ganttTitle .toggle{
  position:absolute;
  left: 0;
  top: 0;
}
.ganttTitle .toggle p{
  cursor: pointer;
}
.machinevue{
  float: left;
}
.selectTime{
  display: flex;
  padding-right: 10px;
  margin-right:10px;
  border-right: 1px solid #ccc;
}
.content{
  display: flex;
}
.ganttPart{
  width: calc(100% - 178px);
}
.tirewrap{
  width: 160px;
  max-height: 675px;
  /* background: black; */
  padding: 5px 3px 0;
  border-radius: 5px;
  margin: 5px;
}

.tirewrap li {
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  background-color: rgba(48, 114, 141, 1);
  margin-bottom: 3px;
  cursor: pointer;
}
.tirewrap li:hover{
  font-weight: bold;
  background-color: rgba(101, 165, 191, 1);
}
.tirewrap .mostshort{
  color: red;
}
.tirewrap .selected{
  font-weight: bold;
  background-color: rgba(101, 165, 191, 1);
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
}
</style>

